import React, { Component } from "react"
// import LazyLoad from "react-lazyload"
import TextBlock from "./FeaturedBlocks/TextBlock"
import ImageBlock from "./FeaturedBlocks/ImageBlock"
import VideoBlock from "./FeaturedBlocks/VideoBlock"
import FaqBlock from "./FeaturedBlocks/FaqBlock"
import ContactForm from "./FeaturedBlocks/ContactForm"
import GeneralTable from "./FeaturedBlocks/GeneralTable"
import ImageGrid from "./FeaturedBlocks/ImageGrid"
import ColumnedImageWithText from "./Blocks/ColumnedImageWithText"
import HorizontalImageText from "./Blocks/HorizontalImageText"
import GalleryCarousel from "./FeaturedBlocks/GalleryCarousel"
import GalleryMasonry from "./FeaturedBlocks/GalleryMasonry"

const FlexibleContentFeatured = (props) => {
	let blocks = ""

	if (props.blocks) {
		blocks = props.blocks.map((block, i) => {
			// console.log(block.__typename)
			// Listing all post types as used on all, need to figure out how to merge into one graphql node
			switch (block.__typename) {
				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_TextBlock':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_TextBlock':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_TextBlock':
					return <TextBlock data={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageBlock':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageBlock':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageBlock':
					return <ImageBlock data={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_VideoBlock':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_VideoBlock':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_VideoBlock':
					return <VideoBlock data={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock':
					return <FaqBlock data={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_ContactForm':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_ContactForm':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_ContactForm':
					return <ContactForm data={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_GeneralTable':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_GeneralTable':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_GeneralTable':
					return <GeneralTable data={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageGrid':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageGrid':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageGrid':
					return <ImageGrid data={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_ColumnedImageWithText':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_ColumnedImageWithText':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_ColumnedImageWithText':
					return <ColumnedImageWithText block={block} padding={false} template="featured" key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_HorizontalImageWithText':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_HorizontalImageWithText':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_HorizontalImageWithText':
					return <HorizontalImageText block={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_GalleryCarousel':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_GalleryCarousel':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_GalleryCarousel':
					return <GalleryCarousel block={block} key={i} />

				case 'WpTwoColumnTemplate_Acftwocolumnflexiblecontent_TwoColumnBlocks_GalleryMasonry':
				case 'WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_GalleryMasonry':
				case 'WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_GalleryMasonry':
					return <GalleryMasonry block={block} key={i} />
						
				default:
					return "";
			}
		})
	}

	return blocks
} 

export default FlexibleContentFeatured